import { render, staticRenderFns } from "./ToLive.vue?vue&type=template&id=0af73680&"
import script from "./ToLive.vue?vue&type=script&lang=js&"
export * from "./ToLive.vue?vue&type=script&lang=js&"
import style0 from "./ToLive.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardText})
